<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    max-width="700px"
  >
    <v-card :loading="loading">
      <v-card-title>
        <span v-if="item.id">Cập nhật dữ liệu</span>
        <span v-else>Thêm mới</span>
        <v-spacer/>
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="close()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-card-title>
      <v-card-text>
        <v-container>
          <div v-if="errors_exist" class="row">
            <div class="col">
              <v-alert
                dense
                outlined
                type="error"
              >
                {{ $vuetify.lang.t('$vuetify.msg.hasError') }}
                <ul>
                  <div v-for="(error, index) in errors">
                    <li :key="index">{{ error[0] }}</li>
                  </div>
                </ul>
              </v-alert>
            </div>
          </div>
          <v-row>
            <v-col cols="12">
              <input 
                type="file" 
                @change="onFilePicked" 
                class="d-none" 
                ref="fileInput" 
                accept="image/*"
              />
              <v-img
                v-if="avatar_url"
                :src="avatar_url"
                class="mx-auto elevation-1"
                @click="onPickFile"
                width="150"
              />
              <v-img
                v-else
                src="@/assets/NoImage.jpg"
                class="mx-auto elevation-1"
                @click="onPickFile"
                width="150"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="item.ten_co_so"
                label="Tên"
                autofocus
                class="require"
                hide-details
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
            >
              <v-select
                v-model="areaSelected"
                :items="areas"
                item-text="name"
                item-value="maqh"
                label="Khu vực"
                return-object
                class="require"
                hide-details
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
            >
              <v-select
                v-model="typeSelected"
                :items="types"
                item-text="ten_loai"
                item-value="id"
                label="Loại cơ sở"
                class="require"
                return-object
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="item.dia_chi"
                label="Địa chỉ"
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="item.lien_he"
                label="Người liên hệ"
                hide-details
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
            >
              <v-text-field
                v-model="item.so_dien_thoai"
                label="Số điện thoại"
                hide-details
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
            >
              <v-text-field
                v-model="item.email"
                label="Email"
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="item.so_gcn"
                label="Số giấy chứng nhận"
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <label>Hình ảnh giấy chứng nhận</label>
              <vue-dropzone 
                ref="myVueDropzone" 
                id="dropzone" 
                :options="dropzoneOptions"
                v-on:vdropzone-success="uploadSuccess"
                v-on:vdropzone-error="uploadError"
                v-on:vdropzone-removed-file="fileRemoved"
                @vdropzone-mounted="loadPictures"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="item.vi_tri"
                label="Vị trí"   
                hide-details
              >
                <template slot="append-outer">
                  <v-btn fab small dark color="primary" @click="showMapDialog">
                    <v-icon>mdi-map-search-outline</v-icon>
                  </v-btn>
                </template>
              </v-text-field>
              <Map 
                :showDialog="mapDialog" 
                :item="map" 
                @confirmed="onMapConfirmed" 
                @cancelled="onMapCancelled"
              />
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="statusSelected"
                :items="status"
                item-text="text"
                item-value="value"
                label="Tình trạng"
                return-object
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <small><span class="pink--text">(*)</span> bắt buộc nhập</small>
        <v-spacer/>
        <v-btn
          color="pink darken-1"
          text
          @click="close"
        >
          Hủy bỏ
        </v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="save(item)"
        >
          Lưu lại
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import Map from '@/views/admin/businesses/Map';
  import vue2Dropzone from 'vue2-dropzone';
  import 'vue2-dropzone/dist/vue2Dropzone.min.css';
  import { mapState, mapActions } from 'vuex';
  export default {
    components: { 
      Map,
      vueDropzone: vue2Dropzone
    },
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      item: {
        type: Object
      }
    },
    data () {
      return {
        loading: false,
        dialog: false,
        avatar_url: null,
        errors_exist: false,
        errors: [],
        types: [],
        typeSelected: null,
        status: [
          {
            value: '0', 
            text: 'Ngừng hoạt động'
          },
          {
            value: '1', 
            text: 'Đang hoạt động'
          }
        ],
        statusSelected: null,
        areas: [],
        areaSelected: null,
        dropzoneOptions: {
          url: null,
          addRemoveLinks: true,
          dictRemoveFile: "×",
          removeType: "server",
          dictDefaultMessage: "<i class='mdi mdi-24px mdi-arrow-collapse-up'></i> <div>Tải lên hình ảnh</div>",
          acceptedFiles: "image/jpeg,image/png,image/jpg",
          thumbnailWidth: 100,
          thumbnailHeight: 100,
          headers: {
            "Authorization": `Bearer ${JSON.parse(localStorage.getItem('user')).token}`,
            "Cache-Control": null, 
            "X-Requested-With": null
          },
        },
        images: [],
        mapDialog: false,
        map: {},
        invalidIds: []
      }
    },
    computed: {
      ...mapState([
        'config'
      ])
    },
    mounted() {
      this.dialog = this.showDialog;
      this.dropzoneOptions.url = `${this.config.beUrl}/api/v1/images`;
      this.getTypes();
      this.getAreas();
    },
    watch: {
      showDialog() {
        this.dialog = false;
        this.errors_exist=false;
        if (this.showDialog) {
          this.dialog = true;
          this.avatar_url = null;
          if(this.item.avatar) {
            this.avatar_url = `${this.config.beUrl}/uploads/${this.item.avatar}`;
          }
          this.typeSelected = this.types.find(
            element => element.id == this.item.loai_id
          );
          this.areaSelected = this.areas.find(
            element => element.maqh == this.item.khu_vuc_id
          );
          this.statusSelected = this.status.find(
            element => element.value == this.item.trang_thai
          );
          this.loadPictures();
        }
      }
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      getTypes () {
        axios.get("api/v1/business-types")
          .then(response => {
            this.types = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      getAreas () {
        axios.get("api/v1/get-district-by-province")
          .then(response => {
            this.areas = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      close() {
        this.dialog = false;
        this.$emit('cancelled');
      },
      showMapDialog(){
        this.map = {
          address: this.item.dia_chi
        };
        this.mapDialog = true;
      },
      onMapConfirmed (item) {
        this.item.vi_tri = `${item.lat};${item.lng}`;
        this.mapDialog = false;
      },
      onMapCancelled () { 
        this.mapDialog = false;
      },
      save(item) {
        const app = this;
        let method = "post";
        let url = `api/v1/businesses`;
        let data = item;

        if(app.typeSelected){
          data.loai_id = app.typeSelected.id;
        }

        if(app.areaSelected){
          data.khu_vuc_id = app.areaSelected.maqh;
        }

        if(app.statusSelected){
          data.trang_thai = app.statusSelected.value;
        }

        data.images = app.images.filter(e => !app.invalidIds.includes(e.id));
        
        if (data.id) {
          method = "patch";
          url = `api/v1/businesses/${data.id}`;
        }

        app.loading=true;

        axios[method](url, data)
          .then((response) => {
            if (response.data && response.data.id) {
              app.$emit('confirmed', response.data);
            }
            app.loading=false;
          }).catch(function (error) {
            app.loading=false;
            app.errors_exist = true;
            if(error.response.status === 422) {
              app.errors = error.response.data || {};
            }
          });
      },
      onPickFile () {
        this.$refs.fileInput.click();
      },
      onFilePicked (event) {
        const app = this;

        const file = event.target.files[0];
        app.avatar_url = URL.createObjectURL(file);

        const config = {
          headers: { 'content-type': 'multipart/form-data' }
        };

        let formData = new FormData();
        formData.append('file', file);

        axios.post('api/v1/images', formData, config)
          .then(function (response) {
            app.item.avatar = response.data.filePath;
          })
          .catch(function (error) {
            app.avatar_url = null;
            app.openSnackbar({ type: 'error' });
          });
      },
      uploadSuccess(file, response) {
        this.openSnackbar({ 
          type: 'success',
          body: 'Tải giấy chứng nhận lên thành công!'
        });
        file.previewElement.querySelector("[data-dz-name]").innerHTML = response.filePath;
        this.images.push(response.fileId);
      },
      uploadError(file, message) {
        this.openSnackbar({ type: 'error' });
      },
      fileRemoved(file, error, xhr) {
        const app = this;
        if(app.dropzoneOptions.removeType == "server") {
          axios.post('api/v1/remove-business-cert-img', {
            businessId: app.item.id,
            fileName: file.previewElement.querySelector("[data-dz-name]").innerHTML
          })
            .then(function (response) {
              file.previewElement.remove();
              app.invalidIds.push(response.data);
              app.openSnackbar({ 
                type: 'success',
                body: 'Xóa giấy chứng nhận thành công!'
              });
            })
            .catch(function (error) {
              app.openSnackbar({ type: 'error' });
            });
        } else {
          file.previewElement.remove();
        }
      },
      loadPictures() {
        if(this.$refs.myVueDropzone) {
          this.dropzoneOptions.removeType = "client";
          this.$refs.myVueDropzone.removeAllFiles(); 
          this.dropzoneOptions.removeType = "server";
          if(this.item.cert_images) {
            this.item.cert_images.forEach(image => {
              if(!this.invalidIds.includes(image.id)) {
                var file = { size: 123, name: image.path, type: "image/png" };
                var url = `${this.config.beUrl}/uploads/${image.path}`;
                this.$refs.myVueDropzone.manuallyAddFile(file, url);
              }
            });
          }
        }
      },
    }
  }
</script>